import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import styles from '../../../styles';
import Logo from '../../core/components/Logo';
import { PreloadImage } from '../../pages/components';
import { ParallaxElement } from '../../parallax/components';

const HeaderParallaxWrap = styled.div`
  padding: 0;
  overflow: hidden;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
`;

const HeaderParallaxElement = styled(ParallaxElement)`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  > div {
    width: 100%;
    height: 100%;
  }
  img {
    width: 100%;
    height: auto;
    transform: translate(0%, -50%);
    top: 50%;
    position: absolute;
  }
`;

const ArticleHeader = styled.div`
  width: 100%;
  left: -${props => (props.breakpoint === 'phone' ? 2.5 : 1.875)}rem;
  right: -${props => (props.breakpoint === 'phone' ? 2.5 : 1.875)}rem;
  top: 0;
  padding-top: ${props =>
    props.breakpoint === 'phone' ? 68.8888888888889 : 25.4301075268817}%;
  padding-left: ${props => (props.breakpoint === 'phone' ? 2.5 : 1.875)}rem;
  padding-right: ${props => (props.breakpoint === 'phone' ? 2.5 : 1.875)}rem;
  position: relative;
  z-index: 0;
  color: ${styles.color.WHITE};
`;

const StyledLogo = styled(Logo)`
  position: absolute;
  top: 3.1875rem;
  left: 3.75rem;

  ${styles.media.tablet`
    top: 3.9375rem;
  `} ${styles.media.phone`
    top: 3.1875rem;
    left: 1.875rem;
  `} z-index: 1000;
`;

const renderLogo = process.env.REACT_APP_MODE === 'webgl';

const PageHeader = props => {
  const { mainImage, breakpoint } = props;
  return (
    <ArticleHeader breakpoint={breakpoint}>
      {renderLogo && <StyledLogo theme={'light'} />}

      <HeaderParallaxWrap>
        <HeaderParallaxElement depth={-10} topAlign>
          <PreloadImage src={mainImage} background />
        </HeaderParallaxElement>
      </HeaderParallaxWrap>
    </ArticleHeader>
  );
};

PageHeader.propTypes = {
  renderLogo: PropTypes.bool,
  breakpoint: PropTypes.string,
  mainImage: PropTypes.string.isRequired,
};

const mapStateToProps = state => {
  const { breakpoint } = state.layout;
  return {
    breakpoint,
  };
};

export default connect(mapStateToProps, null)(PageHeader);



// WEBPACK FOOTER //
// ./src/modules/content/components/PageHeader.js